import React from 'react';
import Head from 'next/head';
import { link } from 'fs';

const Meta = () => {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'ProfessionalService',
    name: 'The Martin’s House | Executive Luxury, Identity Design & Victory-Maison',
    url: 'http://www.jorgedd.com',
    description:
      'The Martin’s House is a global luxury philosophy and creative maison shaping executive identity through Victory-Maison, executive luxury design, and refined brand architecture.',
    founder: {
      '@type': 'Person',
      name: "Martin's"
    },
    sameAs: ['https://linkedin.com/in/jorgeddmartins'],
    image: '/assets/fashion.png',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+447502816932',
      contactType: 'Direct Service'
    }
  };

  return (
    <Head>
      <title key="title">
        The Martin’s House | Executive Luxury, Identity Design & Victory-Maison
      </title>
      <meta key="x-ua" httpEquiv="x-ua-compatible" content="ie=edge" />
      <meta charSet="UTF-8"></meta>
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
      />
      <meta name="robots" content="index,nofollow" />
      <meta
        name="description"
        content="The Martin’s House is a global luxury philosophy and creative maison shaping executive identity through Victory-Maison, executive luxury design, and refined brand architecture."
      />
      <meta
        name="keywords"
        content="The Martin’s House
        Martin’s House luxury
        Martin’s House philosophy
        House of Martin’s
        Victory-Maison
        Victory-Executive Luxury
        executive luxury brand
        luxury identity design
        ultra luxury fashion house
        luxury maison brand
        high net worth lifestyle
        luxury leadership identity
        women CEO luxury fashion
        luxury branding house
        luxury brand architecture
        executive presence design
        intentional luxury fashion
        covenant luxury collection
        luxury handbags for CEOs
        high net worth women fashion
        luxury identity philosophy
        luxury brand for women CEOs
        luxury handbags for executives
        executive luxury accessories
        luxury identity consultancy
        ultra luxury fashion concepts
        "
      />
      <meta name="author" content="George Martin's" />

      {/* Open Graph Meta Tags for Social Media */}
      <meta
        property="og:title"
        content="The Martin’s House is a global luxury philosophy and creative maison shaping executive identity through Victory-Maison, executive luxury design, and refined brand architecture."
      />
      <meta
        property="og:description"
        content="The Martin’s House is a global luxury philosophy and creative maison shaping executive identity through Victory-Maison, executive luxury design, and refined brand architecture."
      />
      <meta property="og:image" content="/assets/fashion.png" />
      <meta property="og:url" content="http://www.jorgedd.com"></meta>
      <meta property="og:type" content="website" />

      <meta
        name="twitter:title"
        content="The Martin’s House — Luxury Editorial for Women CEOs | Faith-Led Storytelling for Fashion, Leadership & Identity"
      />
      <meta
        name="twitter:description"
        content="The Martin’s House is a global luxury philosophy and creative maison shaping executive identity through Victory-Maison, executive luxury design, and refined brand architecture."
      />
      <meta name="twitter:image" content="/assets/fashion.png" />

      <link
        rel="manifest"
        href="/site.webmanifest"
        crossOrigin="use-credentials"
      />

      <link
        rel="apple-touch-icon"
        sizes="180x180"
        href="/apple-touch-icon.png"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="32x32"
        href="/favicon-32x32.png"
      />
      <link
        rel="icon"
        type="image/png"
        sizes="16x16"
        href="/favicon-16x16.png"
      />
      <link rel="icon" type="image/x-icon" href="/favicon.ico" />
      <meta name="msapplication-TileColor" content="#da532c" />
      <meta name="theme-color" content="#ffffff" />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
    </Head>
  );
};

export default Meta;
